import { PawPrint } from "lucide-react";
import { cn } from "@/lib/utils";

const sizes = { sm: "w-4 h-4", md: "w-6 h-6", lg: "w-10 h-10" };

export default function PawSpinner({ size = "md", className = "" }) {
  return (
    <div
      className={cn("flex items-center justify-center gap-2", className)}
      data-testid="paw-spinner"
    >
      {[0, 1, 2].map((i) => (
        <PawPrint
          key={i}
          className={cn(sizes[size], "text-blush animate-paw-walk")}
          style={{ animationDelay: `${i * 0.3}s` }}
        />
      ))}
    </div>
  );
}
